import React, { useState, useEffect } from 'react'
import useSWR from 'swr'
// import MaterialTable from '@material-table/core'
import EmptyVault from './EmptyVault'
// import { apiRequest } from 'store/Misc/apiRequest'
// import { toast } from 'react-toastify'
import { withTranslation } from 'react-i18next'
import { UilArrowLeft } from '@iconscout/react-unicons'
// import TableActionBtn from 'components/TableActionBtn'
// import Icons from 'includes/Icons'
// import { destructureErrorMessage } from 'Helper'
// import HeaderWithExportOptions from 'components/HeaderWithExportOptions'
import Header from './Header'
// import Filter from 'components/Filter'
import TransferForm from './TransferForm'
import Table from './Table'
import Btn from 'components/Btn'
import Spinner from 'components/Spinner'
import { RedemptionVaultContext } from '../context'
import { useLocation } from 'react-router-dom'
// import PreviewModal from 'components/PreviewModal'
// import ReviewForm, { PreviewData } from './ReviewForm'


export default withTranslation()(function RedemptionVaultTable({ t }) {
  const location = useLocation()
  const [params, setParams] = useState('')
  useEffect(() => {
    setParams(location.search)
  }, [location])
  const [queryParams, setQueryParams] = useState({ page: 1, })
  // const queryString = new URLSearchParams(queryParams).toString();

  const { data: redemptionVault } = useSWR(`transactions/type/reward${params}`)
  const [showForm, setShowForm] = useState(false)
  // const [pageDetails, setPageDetails] = useState({ page: 1, pageSize: 5 })

  const closeWithdrawalForm = () => setShowForm(!showForm)
  // useEffect(() => { window.location.assign(`/redemption-vault?${queryString}`)}, [])
  return (
    <RedemptionVaultContext.Provider value={{ queryParams, setQueryParams, showForm, setShowForm }}>
      {/* <ReviewForm 
        content={() => <ReviewForm />}
        title={() => <span className="grid grid-cols-5 items-end text-left">
            <label className="font-semibold text-2xl col-span-3">Review</label>
            <span className="text-sm col-span-2">Sept 16, 2022 17:12:18</span>
          </span>
        }
      /> */}
      {
        !showForm ? (
          <Header closeForm={closeWithdrawalForm} />
        ) : (
          <div className="w-full p-5 bg-white mb-5 rounded-md">
            <Btn
              className="bg-transparent hover:bg-blue-50"
              content={() => <span className="flex items-center justify-start text-primary font-semibold"><UilArrowLeft className="mr-2" /> {t('misc.back')}</span>}
              click={closeWithdrawalForm}
            />
          </div>
        )
      }

      {
        showForm ? (
          <TransferForm />
        ) : (
          <>
            {
              redemptionVault?.length === 0 ? (
                !redemptionVault?.data ? <Spinner /> : <EmptyVault />
              ) : (
                <div className="bg-white p-5 rounded-md overflow-hidden">
                  <Table data={redemptionVault?.data} />
                </div>
              )
            }
          </>
        )
      }
    </RedemptionVaultContext.Provider>
  )
}) 